export const translations = {
  fr: {
    title: 'Ambiance Festive',
    subtitle: 'Transformez votre écran en une expérience magique',
    startScreensaver: 'Lancer Maintenant',
    deployScreensaver: 'Mode Kiosque (Auto)',
    settings: 'Personnaliser',
    autoStartInfo: 'En mode Kiosque, l\'écran de veille s\'active après 30s d\'inactivité.',
    exitInfo: 'Bougez la souris pour revenir',
    madeBy: 'Design par',
    theme: 'Ambiance',
    christmas: 'Noël Classique',
    winter: 'Hiver Givré',
    newYear: 'Nouvel An',
    hanukkah: 'Fête des Lumières',
    backgroundColor: 'Atmosphère',
    night: 'Nuit Étoilée',
    winterBg: 'Aube Glacée',
    aurora: 'Boréale',
    snowflakeCount: 'Intensité Neige',
    animationSpeed: 'Vitesse',
    particleSize: 'Taille Flocons',
    small: 'Fin',
    medium: 'Normal',
    large: 'Gros',
    displayOptions: 'Affichage',
    showClock: 'Horloge',
    showGreeting: 'Message',
    applySettings: 'Sauvegarder',
    snowGlobeImage: 'Votre Souvenir',
    uploadImage: 'Choisir une photo',
    removeImage: 'Supprimer',
    light: 'Calme',
    intense: 'Tempête',
    slow: 'Zen',
    fast: 'Vif',
    yourMemory: 'Souvenir Précieux',
    launching: 'Lancement dans',
    // New Guide Translations
    howToUse: 'Comment ça marche ?',
    close: 'Fermer',
    guide: {
      step1Title: 'Lancement Rapide',
      step1Desc: 'Cliquez sur le bouton de lecture pour démarrer l\'animation immédiatement.',
      step2Title: 'Personnalisation',
      step2Desc: 'Choisissez votre thème, ajustez la neige et ajoutez une photo personnelle.',
      step3Title: 'Mode Kiosque',
      step3Desc: 'Activez ce mode pour que l\'écran de veille se lance automatiquement après 30s d\'inactivité.',
      step4Title: 'Interaction',
      step4Desc: 'Bougez simplement la souris ou touchez l\'écran pour quitter l\'écran de veille.',
    }
  },
  en: {
    title: 'Festive Mood',
    subtitle: 'Transform your screen into a magical experience',
    startScreensaver: 'Launch Now',
    deployScreensaver: 'Kiosk Mode (Auto)',
    settings: 'Customize',
    autoStartInfo: 'In Kiosk Mode, screensaver starts after 30s of inactivity.',
    exitInfo: 'Move mouse to return',
    madeBy: 'Designed by',
    theme: 'Ambience',
    christmas: 'Classic Christmas',
    winter: 'Frosty Winter',
    newYear: 'New Year',
    hanukkah: 'Festival of Lights',
    backgroundColor: 'Atmosphere',
    night: 'Starry Night',
    winterBg: 'Icy Dawn',
    aurora: 'Aurora',
    snowflakeCount: 'Snow Intensity',
    animationSpeed: 'Speed',
    particleSize: 'Flake Size',
    small: 'Fine',
    medium: 'Normal',
    large: 'Big',
    displayOptions: 'Display',
    showClock: 'Clock',
    showGreeting: 'Message',
    applySettings: 'Save Changes',
    snowGlobeImage: 'Your Memory',
    uploadImage: 'Choose Photo',
    removeImage: 'Remove',
    light: 'Calm',
    intense: 'Storm',
    slow: 'Zen',
    fast: 'Fast',
    yourMemory: 'Precious Memory',
    launching: 'Launching in',
    // New Guide Translations
    howToUse: 'How it works',
    close: 'Close',
    guide: {
      step1Title: 'Quick Launch',
      step1Desc: 'Click the play button to start the animation immediately.',
      step2Title: 'Customization',
      step2Desc: 'Choose your theme, adjust snow settings, and upload a personal photo.',
      step3Title: 'Kiosk Mode',
      step3Desc: 'Enable this mode to automatically start the screensaver after 30s of inactivity.',
      step4Title: 'Interaction',
      step4Desc: 'Simply move your mouse or touch the screen to exit the screensaver.',
    }
  },
  es: {
    title: 'Ambiente Festivo',
    subtitle: 'Transforma tu pantalla en una experiencia mágica',
    startScreensaver: 'Iniciar Ahora',
    deployScreensaver: 'Modo Kiosco (Auto)',
    settings: 'Personalizar',
    autoStartInfo: 'En modo Kiosco, el protector se activa tras 30s de inactividad.',
    exitInfo: 'Mueve el ratón para volver',
    madeBy: 'Diseñado por',
    theme: 'Ambiente',
    christmas: 'Navidad Clásica',
    winter: 'Invierno Helado',
    newYear: 'Año Nuevo',
    hanukkah: 'Festival de Luces',
    backgroundColor: 'Atmósfera',
    night: 'Noche Estrellada',
    winterBg: 'Amanecer Helado',
    aurora: 'Aurora',
    snowflakeCount: 'Intensidad Nieve',
    animationSpeed: 'Velocidad',
    particleSize: 'Tamaño Copos',
    small: 'Fino',
    medium: 'Normal',
    large: 'Grande',
    displayOptions: 'Visualización',
    showClock: 'Reloj',
    showGreeting: 'Mensaje',
    applySettings: 'Guardar Cambios',
    snowGlobeImage: 'Tu Recuerdo',
    uploadImage: 'Elegir Foto',
    removeImage: 'Eliminar',
    light: 'Calma',
    intense: 'Tormenta',slow: 'Zen',
    fast: 'Rápido',
    yourMemory: 'Recuerdo Precioso',
    launching: 'Iniciando en',
    // New Guide Translations
    howToUse: '¿Cómo funciona?',
    close: 'Cerrar',
    guide: {
      step1Title: 'Inicio Rápido',
      step1Desc: 'Haz clic en el botón de reproducción para iniciar la animación inmediatamente.',
      step2Title: 'Personalización',
      step2Desc: 'Elige tu tema, ajusta la nieve y sube una foto personal.',
      step3Title: 'Modo Kiosco',
      step3Desc: 'Activa este modo para iniciar automáticamente el protector tras 30s de inactividad.',
      step4Title: 'Interacción',
      step4Desc: 'Simplemente mueve el ratón o toca la pantalla para salir.',
    }
  },
  de: {
    title: 'Festliche Stimmung',
    subtitle: 'Verwandeln Sie Ihren Bildschirm in ein magisches Erlebnis',
    startScreensaver: 'Jetzt Starten',
    deployScreensaver: 'Kiosk-Modus (Auto)',
    settings: 'Anpassen',
    autoStartInfo: 'Im Kiosk-Modus startet der Bildschirmschoner nach 30s Inaktivität.',
    exitInfo: 'Maus bewegen zum Zurückkehren',
    madeBy: 'Design von',
    theme: 'Ambiente',
    christmas: 'Klassische Weihnacht',
    winter: 'Frostiger Winter',
    newYear: 'Neujahr',
    hanukkah: 'Lichterfest',
    backgroundColor: 'Atmosphäre',
    night: 'Sternennacht',
    winterBg: 'Eisiger Morgen',
    aurora: 'Aurora',
    snowflakeCount: 'Schneestärke',
    animationSpeed: 'Geschwindigkeit',
    particleSize: 'Flockengröße',
    small: 'Fein',
    medium: 'Normal',
    large: 'Groß',
    displayOptions: 'Anzeige',
    showClock: 'Uhr',
    showGreeting: 'Nachricht',
    applySettings: 'Speichern',
    snowGlobeImage: 'Ihr Andenken',
    uploadImage: 'Foto wählen',
    removeImage: 'Entfernen',
    light: 'Ruhig',
    intense: 'Sturm',
    slow: 'Zen',
    fast: 'Schnell',
    yourMemory: 'Kostbare Erinnerung',
    launching: 'Startet in',
    // New Guide Translations
    howToUse: 'Wie es funktioniert',
    close: 'Schließen',
    guide: {
      step1Title: 'Schnellstart',
      step1Desc: 'Klicken Sie auf den Play-Button, um die Animation sofort zu starten.',
      step2Title: 'Anpassung',
      step2Desc: 'Wählen Sie Ihr Thema, passen Sie den Schnee an und laden Sie ein persönliches Foto hoch.',
      step3Title: 'Kiosk-Modus',
      step3Desc: 'Aktivieren Sie diesen Modus für automatischen Start nach 30s Inaktivität.',
      step4Title: 'Interaktion',
      step4Desc: 'Bewegen Sie einfach die Maus oder berühren Sie den Bildschirm zum Beenden.',
    }
  }
};